import {
  AnalyticsClient as CoreAnalyticsClient,
  AnalyticsPageviewProperties as CorePageviewProperties,
} from '@modernhealth/analytics-core';

import { getGlobalFreshpaint } from './Freshpaint';

export {
  AnalyticsEventType,
  ExternalAnalyticsSDK,
  AnalyticsProperties,
} from '@modernhealth/analytics-core';

// These keys and their value types are defined in our wiki.
// @see https://www.notion.so/modernhealth/Usage-Tracking-Analytics-9a30ca87824749c5b9db9960294c25ac
export interface AnalyticsPageviewProperties extends CorePageviewProperties {
  path_name: string;
  path_pattern: string;
  path_pattern_exact: boolean;
}

export class AnalyticsClient extends CoreAnalyticsClient<AnalyticsPageviewProperties> {
  constructor(public appName: string) {
    super(appName, [getGlobalFreshpaint]);
  }
}
